import { API } from 'aws-amplify'
import { client } from '../config/globals'
import axios from 'axios'

export const HTTPS = {
  get: (path) => {
    return new Promise((resolve, reject) => {
      const options = {
        headers: {
          Accept: 'application/json'
        }
      }
      API.get(client.apiName, `${client.apiPath}${path}`, options)
        .then(response => {
          resolve(response)
        }).catch(error => { reject(error.response) })
    })
  },
  put: (props) => {
    return new Promise((resolve, reject) => {
      const request = {
        body: { ...props }
      }
      API.put(client.apiName, client.apiPath, request)
        .then(response => {
          const newState = {}
          newState.dateModified = response.dateModified
          resolve(newState)
        }).catch(error => { reject(error.response) })
    })
  },
  delete: (props) => {
    return new Promise((resolve, reject) => {
      const request = {
        body: { ...props }
      }
      API.del(client.apiName, `${client.apiPath}/row`, request)
        .then(response => {
          const newState = {}
          newState.dateModified = response.dateModified
          resolve(newState)
        }).catch(error => { reject(error.response) })
    })
  },
  post: (props) => {
    return new Promise((resolve, reject) => {
      const request = {
        body: { ...props }
      }
      API.post(client.apiName, client.apiPath, request)
        .then(response => {
          const newState = {}
          newState.id = response.id
          newState.dateCreated = response.dateCreated
          resolve(newState)
        }).catch(error => { reject(error.response) })
    })
  },
}

export const HTTP = {
  get: (url) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  delete: (url, data) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
  post: (url, data) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => { resolve(response) })
        .catch((error) => { reject(error) })
    })
  },
}
